import {bindable, inject, LogManager} from "aurelia-framework";
import * as _ from "lodash";
import {I18N} from "aurelia-i18n";
import {Client} from '../api/client';

const logger = LogManager.getLogger('property-display');

@inject(Client, I18N)
export class ColumnLoader {
    constructor(client, i18n) {
        this.client = client;
        this.i18n = i18n;
    }

    async loadColumns(object, properties) {
        let columns = [];

        for (let property of properties) {

            let parts = property.split('.');
            let currentModelId = object.modelId;

            for (let i = 0; i < parts.length; i++) {

                let currentPart = parts[i];
                let list = await this.client.get(currentModelId + '/list?_locale=' + this.i18n.getLocale(), 60);

                let fullPartColumn = _.find(list.columns, (o) => {
                    return o.property === parts.slice(i).join('.')
                });

                if (fullPartColumn) {

                    fullPartColumn = _.cloneDeep(fullPartColumn);
                    fullPartColumn.nestedProperty = parts.slice(0, -1).join('.');

                    columns.push(fullPartColumn);

                    break;
                }

                if (i + 1 === parts.length) {
                    let column = _.find(list.columns, (o) => {
                        return o.property === currentPart
                    });

                    if (!column) {
                        logger.error('Column not found ' + currentPart);
                        break;
                    }

                    column = _.cloneDeep(column);
                    column.nestedProperty = parts.slice(0, -1).join('.');

                    columns.push(column);

                    break;
                }

                let column = _.find(list.referenceFields ?? [], (o) => {
                    return o.fieldName === currentPart
                });

                if (!column) {
                    logger.error('Reference field not found ' + currentPart + ' on ' + currentModelId);
                    break;
                }

                currentModelId = column.options.modelId;
            }
        }

        return columns;
    }
}
